import fetcher from '@/services/fetcher'
import type { Nullable } from '@/types'
import { SiteSlug } from '@goodlifeplus/themes'
import { defineStore } from 'pinia'

export type Moment = {
  id: string
  title: string
  youtube_id: string
  highlighted?: boolean
  image?: string
}

type MomentsStoreState = {
  moments: Map<string, Moment>
  fetchPromise: Promise<Array<Moment>> | null
}

export const useMomentsStore = defineStore('moments', {
  state: (): MomentsStoreState => ({
    moments: new Map<string, Moment>(),
    fetchPromise: null,
  }),

  getters: {
    momentsArray(): Array<Moment> {
      return Array.from(this.moments.values()).sort(
        (a, b) => Number(a.id) - Number(b.id)
      )
    },
    highlightedMoments(): Array<Moment> {
      return this.momentsArray.filter((m: Moment) => m.highlighted)
    },
  },

  actions: {
    async fetchMoments(): Promise<void | Array<Moment>> {
      if (this.fetchPromise) {
        return this.fetchPromise
      }

      if (this.moments.size) {
        return this.momentsArray
      }

      const momentsFile =
        import.meta.env.GLP_SITE_SLUG === SiteSlug.TrueNorth
          ? '/data/true-north-moments.json'
          : '/data/moments.json'

      this.fetchPromise = fetcher
        .get<Moment>(momentsFile, false, {
          key: 'id',
          map: this.moments,
        })
        .then(() => this.momentsArray)
        .catch((error) => {
          // TODO: Add Datadog custom log
          this.fetchPromise = null
          return this.momentsArray
        })

      return this.fetchPromise
    },
  },
})
